//THIS FILE IS NOT IN USE 

import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { getGSTR2BSummary, getGSTR2BDetails } from '../api/misApis';
import { useNavigate } from 'react-router-dom';

function GSTRECO1stTABLE() {
  const [summary, setSummary] = useState([]);
  const [details, setDetails] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    getGSTR2BSummary()
      .then((res) => setSummary(res.data))
      .catch((err) => console.error(err));
  }, []);

  const handleRowClick = (row) => {
    setSelectedSupplier(row.Supplier_Logic);
    getGSTR2BDetails(row.Supplier_Logic)
      .then((res) => setDetails(res.data))
      .catch((err) => console.error(err));
  };

  const summaryColumns = [
    { name: 'GSTIN GSTR2B', selector: row => row.GSTIN_GSTR2B, sortable: true },
    { name: 'Supplier GSTR2B', selector: row => row.Supplier_GSTR2B, sortable: true },
    { name: 'Month GSTR2B', selector: row => row.Month_GSTR2B },
    { name: 'GSTIN Logic', selector: row => row.GSTIN_Logic },
    { name: 'Supplier Logic', selector: row => row.Supplier_Logic },
    { name: 'Month Logic', selector: row => row.Month_Logic },
    { name: 'InvoiceValueDiff', selector: row => row.InvoiceValueDiff },
    { name: 'TaxableValueDiff', selector: row => row.TaxableValueDiff },
    { name: 'IntegratedTaxDiff', selector: row => row.IntegratedTaxDiff },
    { name: 'CentralTaxDiff', selector: row => row.CentralTaxDiff },
    { name: 'StateUTTaxDiff', selector: row => row.StateUTTaxDiff },
    { name: 'DiffFlag', selector: row => row.DiffFlag },
  ];

  const detailColumns = [
    { name: 'Invoice No', selector: row => row.InvoiceNo_GSTR2B },
    { name: 'Supplier', selector: row => row.Supplier_GSTR2B },
    { name: 'Invoice Date', selector: row => row.InvoiceDate_GSTR2B },
    { name: 'Invoice Value Diff', selector: row => row.InvoiceValueDiff },
    { name: 'Taxable Value Diff', selector: row => row.TaxableValueDiff },
    { name: 'Integrated Tax Diff', selector: row => row.IntegratedTaxDiff },
    { name: 'Central Tax Diff', selector: row => row.CentralTaxDiff },
    { name: 'State UT Tax Diff', selector: row => row.StateUTTaxDiff },
    { name: 'Diff Flag', selector: row => row.DiffFlag },
  ];

  return (
   <div className="w-full min-h-screen px-4 py-6 md:px-8 bg-gray-50">
  <div className="w-full max-w-[100vw] overflow-x-auto">
    <div className="min-w-[1200px] max-w-[1400px] mx-auto bg-white rounded-xl shadow p-4">
      <div className="flex justify-between items-center mb-4 flex-wrap gap-4">
        <h2 className="text-2xl font-semibold text-gray-800">GSTR-2B Summary</h2>
        <button
          onClick={() => navigate('/GST-RECO')}
          className="flex items-center gap-1 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition-all"
        >
          ➕ View Full Table
        </button>
      </div>

      <div className="overflow-x-auto">
        <DataTable
          columns={summaryColumns}
          data={summary}
          pagination
          onRowClicked={handleRowClick}
          highlightOnHover
          pointerOnHover
          responsive
          dense
          striped
          customStyles={{
            cells: {
              style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '150px',
              },
            },
            headCells: {
              style: {
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
              },
            },
          }}
        />
      </div>

      {selectedSupplier && (
        <div className="mt-8">
          <h3 className="text-lg font-medium text-gray-700 mb-3">
            Invoice Details for: <span className="font-semibold text-black">{selectedSupplier}</span>
          </h3>
          <div className="overflow-x-auto">
            <DataTable
              columns={detailColumns}
              data={details}
              pagination
              highlightOnHover
              responsive
              striped
              dense
            />
          </div>
        </div>
      )}
    </div>
  </div>
</div>

  );
}

export default GSTRECO1stTABLE;
